module.exports = __webpack_public_path__ + "static/media/icon-hipercard.88f67d79.png";